import { Component, OnInit, inject } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import Utils from '../utils/utils';
import {environment} from '../../environments/environment';
import {ILogin, Login} from '../../shared/model/login.model';
import { MatCard, MatCardTitle } from '@angular/material/card';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.css'],
    imports: [MatCard, MatCardTitle, MatProgressSpinner, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatIcon, MatError, MatButton]
})
export class UserComponent implements OnInit {
  private http = inject(HttpClient);
  private fb = inject(UntypedFormBuilder);
  private router = inject(Router);
  private toastr = inject(ToastrService);


  form: UntypedFormGroup = this.fb.group({
    password: ['', [Validators.required, Validators.minLength(8)]],
    passwordConfirm: ['', Validators.required],
    confirmationCode: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]]
  }, {
    validator: Utils.passwordMatchValidator
  });
  isLoading = false;
  nextStep = false;
  error = '';
  apiUrl = environment.apiUrl;
  showPassword = false;
  showPasswordRepeat = false;
  login: ILogin = new Login();

  ngOnInit(): void {
    this.login.username = localStorage.getItem('email');
  }

  showSuccess(message: string): void {
    this.toastr.success(message, 'OK', {
      timeOut: 3000
    });
  }

  showError(error: string): void {
    this.toastr.error(error, 'Erreur', {
      timeOut: 3000
    });
  }

  public sendConfirmationCodePassword(): void {
    this.isLoading = true;
    this.http.post(this.apiUrl + '/auth/change-password', this.login, {observe: 'response', responseType: 'text'})
      .subscribe(() => {
          this.nextStep = true;
          this.isLoading = false;
        }, (err: string) => {
          switch (err) {
            case 'ERR_MAIL_NOT_SENT':
              this.error = 'Impossible d\'envoyer le mail de confirmation, merci de réessayer dans quelques minutes';
              break;

            case 'ERR_ACC_NOT_EXIST':
              this.error = 'Ce compte n\'existe pas';
              break;

            default:
              this.error = 'Merci de réessayer dans quelques instants';
              break;
          }
          this.showError(this.error);
          this.isLoading = false;
        }
      );
  }

  public validConfirmationCode(): void {
    this.isLoading = true;
    this.http.post(this.apiUrl + '/auth/password-validation', this.login, {observe: 'response', responseType: 'text'})
      .subscribe(() => {
          localStorage.removeItem('accessToken');
          this.isLoading = false;
          this.router.navigate(['login']);
          this.showSuccess('Vous avez bien changé le mot de passe de votre compte. Vous pouvez désormais vous connecter avec celui-ci');
        }, (err: string) => {
          switch (err) {
            case 'ERR_BAD_ACTIVATION_CODE':
              this.error = 'Code de confirmation invalide';
              break;

            case 'ERR_ACC_NOT_EXIST':
              this.error = 'Ce compte n\'existe pas';
              break;

            case 'ERR_EXPIRED_CODE':
              this.error = 'Le code de validation est expiré, un nouveau code vient de vous être envoyé par email';
              this.resendConfirmationCode(true);
              break;

            default:
              this.error = 'Merci de réessayer dans quelques instants';
              break;
          }
          this.showError(this.error);
          this.isLoading = false;
        }
      );
  }

  public deleteAccount(): void {
    if (confirm('Êtes-vous sûr de vouloir supprimer votre compte? Toutes les données seront supprimées et il sera impossible de les récupérer ensuite')) {
      this.isLoading = true;
      this.http.get(this.apiUrl + '/auth/delete-account', {observe: 'response', responseType: 'text'})
        .subscribe(() => {
            localStorage.removeItem('accessToken');
            location.reload();
            this.router.navigate(['login']);
            this.isLoading = false;
            this.showSuccess('Votre compte ainsi que toutes les données associées ont bien été supprimés');
          }, (error: string) => {
            switch (error) {
              case 'ERR_ACC_NOT_FOUND':
                this.showError(this.error);
                this.error = 'Impossible de supprimer votre compte car votre compte n\'existe pas';
                break;

              default:
                this.showError(this.error);
                this.error = 'Merci de réessayer dans quelques instants';
                break;
            }
            this.isLoading = false;
          }
        );
    }
  }

  public resendConfirmationCode(outOfTimeCode: boolean): void {
    this.http.post(this.apiUrl + '/auth/resend-code-user', localStorage.getItem('accessToken'), {
      observe: 'response',
      responseType: 'text'
    })
      .subscribe(() => {
        if (!outOfTimeCode) {
          this.showSuccess('Un nouveau code vient de vous être envoyé sur votre adresse email');
        }
      }, (error: string) => {
        switch (error) {
          case 'ERR_MAIL_NOT_RESENT':
            this.showError('Impossible de renvoyer le mail de confirmation, merci de réessayer dans quelques minutes');
            break;

          case 'ERR_USER_NOT_FOUND':
            this.showError('L\'utilisateur n\'existe pas');
            break;

          default:
            this.showError('Merci de réessayer dans quelques instants');
            break;
        }
      });
  }

  clickShowPassword(): void {
    this.showPassword = !this.showPassword;
  }

  clickShowPasswordRepeat(): void {
    this.showPasswordRepeat = !this.showPasswordRepeat;
  }

  isCurrentProvider(provider: string): boolean {
    return localStorage.getItem('provider') === provider;
  }
}
